import classNames from 'classnames';
import React, { useContext } from 'react';
import { DefaultLayoutContext } from '../../contexts/DefaultLayoutContext';
import { Category } from '../../types/Category';
import CategoriesComponent from '../categories/categories';
import styles from './business-article-categories-block.module.scss';

interface Props {
    categories: Category[];
}

const ArticleCategoriesBlock: React.FC<Props> = (props: Props) => {
    const { categories } = props;
    const defaultLayoutContext = useContext(DefaultLayoutContext);
    return (
        <div className={styles.articleCategoriesContainer}>
            <p className={classNames(styles.categoriesHeading, styles[defaultLayoutContext.type || ''])}>Categories</p>
            <CategoriesComponent type="LARGE" categories={categories} color={defaultLayoutContext.type === 'light' ? 'white' : 'grey'} />
        </div>
    );
};

export default ArticleCategoriesBlock;
